export const CURRENT_NOTIFICATION_COUNT = "CURRENT_NOTIFICATION_COUNT";
export const CLEAR_CURRENT_NOTIFICATION_COUNT =
  "CLEAR_CURRENT_NOTIFICATION_COUNT";
export const APPEND_NEW_NOTIFICATION = "APPEND_NEW_NOTIFICATION";
export const INCREASE_NOTIFICATION_COUNT = "INCREASE_NOTIFICATION_COUNT";
export const DECREASE_NOTIFICATION_COUNT = "DECREASE_NOTIFICATION_COUNT";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";
export const SET_CURRENT_LIST_NOTIFICATION = "SET_CURRENT_LIST_NOTIFICATION";
